import AuthForm from "@/pages/AuthForm";

export default function AuthPage() {
  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="auth-page">
      <p className="eyebrow text-accent mb-4">Your account</p>
      <h1 className="font-display font-black uppercase tracking-tighter text-4xl mb-10">Log in or sign up</h1>
      <AuthForm redirectTo="/dashboard" />
    </div>
  );
}
